import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=26b7c809&scoped=true&"
import script from "./CategoriesSection.vue?vue&type=script&lang=js&"
export * from "./CategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSection.vue?vue&type=style&index=0&id=26b7c809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7c809",
  null
  
)

export default component.exports